import backendV2Service from './backend-v2.service';

export interface CreateSchoolPayload {
  name: string;
  baseCountryId: number;
  operationYear: number;
  calendarTypeId: number;
  paymentByTypeId?: number;
  schoolGroupId?: number;
  rbd?: string;
  contact?: string;
  phone?: string;
  state?: string;
  timeZone?: string;
}

export interface CreateSchoolResult {
  status: string;
  content: { id: number; name: string };
}

const unwrap = <T>(req: Promise<{ data: T }>) => req.then(({ data }) => data);

export default {
  create: (payload: CreateSchoolPayload): Promise<CreateSchoolResult> => unwrap(
    backendV2Service.post<CreateSchoolResult>('/schools', payload),
  ),
};
